export enum TemplateTypeEnum {
  TEXT = 'TEXT',
  SEQUENCE = 'SEQUENCE',
  MPM = 'MPM',
}
